import React from "react";
import { useSelector } from "react-redux";
import { ALL_SERVICES } from "../../payments/paymentConstants";

export function isDiscountValid({ discount = null, service = "" }) {
  if (!discount) return false;
  return (
    discount.isValid &&
    (discount.couponDetails.services === service ||
      discount.couponDetails.services === ALL_SERVICES)
  );
}

export default function DiscountMode({
  service = "",
  isShowStepText = true,
  note = null,
  isAdmin = false,
  ...props
}) {
  const { discount } = useSelector((state) => state.employer);

  if (isDiscountValid({ discount, service }) || (isAdmin && discount.isValid)) {
    return (
      <div className="dashboard-message body-blue-text" {...props}>
        <span className="semi-bold">
          {discount.couponDetails.name} ({discount.couponDetails.details}){" "}
        </span>
        <span>
          is applied to your account.
          {isShowStepText && (
            <span>
              <br />
              Discount will be applied at checkout.
            </span>
          )}
          {note}
        </span>
      </div>
    );
  } else {
    return null;
  }
}
